import { useMemo, useState } from 'react';

const useBoolean = (
  initialValue = false,
): [
  boolean,
  {
    toggle: () => void;
    reset: () => void;
    setTrue: () => void;
    setFalse: () => void;
  },
] => {
  const [bool, setBool] = useState<boolean>(initialValue);

  const handlers = useMemo(
    () => ({
      toggle: () => setBool((prev) => !prev),
      reset: () => setBool(initialValue),
      setTrue: () => setBool(true),
      setFalse: () => setBool(false),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return [bool, handlers];
};

export default useBoolean;
